import React from "react";
import { cardrive, line } from "../../../assets/images";
import { how } from "../../../constants/how";

const How: React.FC = () => {
  return (
    <div className="mt-24">
      <div className=" w-[90%] flex flex-col gap-1 md:hidden mx-auto text-center">
        <h2 className="font-Poppins font-bold text-[24px] uppercase  text-darkText">
          HOW IT WORKS
        </h2>
        <span className="font-Poppins text-[16px] text-[#1d1e21] font-normal leading-10">
          Rent your desired car in just 3 steps
        </span>
      </div>
      <div className="container w-[90%] md:w-3/4 mx-auto  flex justify-center md:justify-around items-center ">
        <div className="w-1/2">
          <img src={cardrive} alt="" className="object-contain" />
        </div>
        <div className="space-y-4 lg:space-y-12 w-1/2">
          <div className=" flex-col gap-4 hidden md:flex">
            <h2 className=" font-Poppins text-[24px] uppercase text-left text-darkText">
              HOW IT WORKS
            </h2>
            <span className="font-Poppins text-[32px] font-medium leading-10">
              Rent your desired car in just 3 steps
            </span>
          </div>
          {how.map((item, index) => (
            <div className="flex" key={index}>
              <div className="  ">
                <div className="flex flex-col gap-4  lg:gap-6">
                  <div className="flex items-center gap-2 lg:gap-12">
                    <div className="">
                      <div className="bg-white flex justify-center items-center rounded-lg md:rounded-[24px]">
                        <img
                          src={item.img}
                          alt=""
                          className="p-2 h-10 w-14  md:p-7 md:h-24 md:w-32  mx-auto"
                        />
                      </div>
                    </div>
                    <div className=" ">
                      <h3 className="font-Poppins font-semibold  text-[12px] md:text-[20px] text-darkText ">
                        {item.title}
                      </h3>
                      <p className="text-greyText font-Poppins  text-[10px] md:text-[16px] font-normal">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                  <div className="">
                    {index !== how.length - 1 ? (
                      <img
                        src={line}
                        alt=""
                        className="object-contain h-14 md:h-[90px] flex justify-center items-center ml-4 md:ml-12"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default How;
